
export const Page6English = () => {
  return (
    <div className="page-container">
      <h1>Miraculous Banyan Tree: </h1>
      <p>
        There is a banyan tree. No one knows how old this tree is. It has never
        fallen down before. The storms that have blown through this area many
        times have not shaken this tree. Many big trees have fallen in the
        strong storms. But this banyan tree, which has never fallen, has never
        fallen down. Its leaves ripen on one side while the other side remains
        green. This is a miraculous banyan tree,<strong>Mr. S. Durairaj</strong>
        of Bangalore, who helped in the renovation and consecration of the two
        temples, the Sri Ayyanar Temple and the Sri Adhiyannan Temple, in
        Kolapadu, and who did the entire work in a great way, tells us about his
        work.
      </p>
      <p>
        Hello, The Sri Sundareswarar Temple located in Kolapadu was renovated
        and consecrated with the financial support and cooperation of the
        villagers. Later, many villagers asked me to make an effort to renovate
        both the Aiyanar temple and the Adhiannan temple. I had told the people
        who had helped in the renovation of the Shiva temple that it would be
        difficult to get donations again in a short time and fulfill the wishes
        of the people, so I could complete that too "when the time is right".
      </p>
      <p>
        One fine day, I received a call from the Aiyanar temple. When I went to
        see him, Mr. Durairaj, who had come from Bangalore to perform puja at
        the temple, had called me.
      </p>
      <p>
        They said that I had called them to ask for your cooperation in
        renovating both the temples and performing the Kumbabhishekam. I was
        surprised. I thought that the expected "time has come". I said that the
        renovation and consecration of both the temples would cost a lot, so
        first of all, I said, please help me. They have said that our family,
        relatives and friends will bear the entire cost, and they said that they
        should get the help of the villagers and help the work to be done
        smoothly and efficiently. I said, "Come back after ten days, I will
        bring the mason, the carpenter, and the painter. We will talk about it
        that day." As I said, the villagers met on the appointed day and it was
        decided to do the renovation. The total cost was estimated to be around
        five lakhs. They gave me a huge amount that day to start the work. I was
        very scared.
      </p>
    </div>
  );
};
